import { useState } from "react";
import { useNavigate, Link, Navigate } from "react-router-dom";
import { loginAccount } from "../api/client";
import { useAuth } from "../context/AuthContext";
import FastSendLogo from "../components/FastSendLogo";
import ContactFooter from "../components/ContactFooter";

const ROLE_HOME = { user: "/dashboard", rider: "/rider/dashboard", admin: "/admin/riders", support: "/admin/riders" };

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { account, login } = useAuth();
  const navigate = useNavigate();

  if (account) {
    return <Navigate to={ROLE_HOME[account.role] || "/admin/riders"} replace />;
  }

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await loginAccount("admin", form);
      // The admin's own `role` ("admin" or "support") is what the backend
      // actually gated the JWT on (see authController.login) — support
      // accounts need account.role === "support" here too so
      // ProtectedRoute/AdminNav scope them correctly, not blanket "admin".
      login(data.token, data.admin.role || "admin", data.admin);
      navigate("/admin/riders");
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page">
      <div className="brand-header" style={{ marginBottom: "28px" }}>
        <FastSendLogo size="medium" showTagline={true} />
        <h2 style={{ fontSize: "18px", fontWeight: 800, marginTop: "16px", color: "var(--text-primary)" }}>
          ⚙️ Admin Portal
        </h2>
        <p className="brand-tagline">Restricted access — authorized administrators only</p>
      </div>

      <form onSubmit={handleSubmit}>
        <input name="email" type="email" placeholder="Admin email address" value={form.email} onChange={handleChange} required />
        <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required />
        {error && <p className="error">{error}</p>}
        <button type="submit" disabled={loading}>{loading ? "Logging in…" : "Log in to Admin Portal"}</button>
      </form>

      <p className="text-link">
        Not an admin? <Link to="/login">Go to customer / dispatcher login</Link>
      </p>

      <ContactFooter />
    </div>
  );
}
